<template>
    <div>
      <SfeInput
        :autocomplete="autocomplete" 
        :value="value" 
        id="password" 
        :type="[passwordFieldType ? 'text' : 'password']"  
        @input="handlePasswordInput" 
        placeholder="********"
      >
        <template #rightAddon>
          <span @click.prevent="togglePassword" class="material-icons cursor-pointer fs-16 fw-400">{{ passwordFieldType ? 'visibility' : 'visibility_off'}}</span>
        </template>
      </SfeInput>
    </div>
</template>

<script>
export default {
  name: 'PasswordInput',
    props:{
        value: {
        type: String,
        default: ""
        },
        autocomplete: {
          default: "off",
          type: String
        }
    },
    data() {
        return {
            passwordFieldType: false
        }
    },
methods: {
  handlePasswordInput(event) {
    this.$emit('input', event);
  },
    togglePassword(){
      this.passwordFieldType = !this.passwordFieldType
    },
},
computed: {
  update(event){
        this.$emit('input', event)
    }
}
}
</script>

<style>

.passwordTogglerContainer{
        float: right;
        /*padding-right: -20px;*/
        margin-top: -40px;
        position: relative;
        cursor: pointer;
        /*width: 50px;*/
      }
</style>